import { Dropdown, FormControl, DropdownButton, Button } from 'react-bootstrap'
import { Component, useState, useEffect, useRef } from 'react'
import React from 'react';
import '../../index.css'

/**
 * Custom elements for a custom dropdown. 
 * Adaption of: https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
*/

/**
 * CustomToggle is used for opening/closing a custom dropdown menu.
 * forwardRef is used for dropdown to access the DOM node to position the menu
 * @param {any} children props to be displayed when the dropdown is opened; custom menu in normal cases
 * @param {any} onClick event for opening/closing the children
*/
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
        variant="secondary"
        href=""
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}>
        {children}
        &#x8;
        &#x25bc;
  </Button>
));

/**
 * CustomMenu opens when a CustomToggle is clicked
 * Dropdown needs forwardRef to access the DOM of the Menu to measure it
 * @param {any} children props to be displayed inside of menu
 * @param {string} style string representing css styles
 * @param {string} className string representing css class
 * @param {string} labeledBy unique label for the object
*/
const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        const [value, setValue] = useState('');
        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}>

                <FormControl
                    ref={function (input) {
                        if (input != null) {
                            input.focus();
                        }
                    }}
                    autoFocus
                    className="mx-3 my-2 w-auto"
                    placeholder={window.i18n('filter')}
                    onChange={(e) => { setValue(e.target.value) }}
                    value={value}
                />
                <ul className="list-unstyled">
                    {React.Children.toArray(children).map(
                        (child) =>
                            (value && React.Children.toArray(child.props.children).filter(x => x.props != undefined && x.props.disabled == false
                               && x.props.children.toString().toLowerCase().includes(value.toLowerCase()))
                            ),
                    )}
                </ul>
                <ul className="list-unstyled">
                    {React.Children.toArray(children).filter(
                        (child) =>
                            (!value || child.props.disabled == false &&
                                (child.props.children[0].props.children.toLowerCase().includes(value.toString().toLowerCase()) )),
                    )}
                </ul>
            </div>
        );
    },
);


export { CustomMenu, CustomToggle }